import { render, staticRenderFns } from "./TwoColumnsContent.vue?vue&type=template&id=03767244&"
import script from "./TwoColumnsContent.vue?vue&type=script&lang=js&"
export * from "./TwoColumnsContent.vue?vue&type=script&lang=js&"
import style0 from "./TwoColumnsContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports